function composeBiEvent(eventId: number, fields = {}) {
  return {
    src: 5,
    evid: eventId,
    fields: {
      ...fields,
    },
  };
}

const addressSelect = (fields = {}) => composeBiEvent(1363, fields);

export default {
  addressSelect,
};
